(function($, window, document, name, api, cls) {
    if (!!window[name]) {
        console.group("Redefinition detected: base.js");
        console.warn("WidgetAPI code was already executed. Skipping...");
        console.warn("WidgetAPI-Object:", window[name]);
        console.groupEnd();
        return;
    }

    var underscore_template_settings = {
        interpolate: /\{\{(.+?)\}\}/g
    };

    var require = function _require(name) {
        return window.TMModuleLoader.require(name);
    };

    var BaseWidget = function() {

    };

    /////////////////////////////////////////////////////////////////////////////////////
    // WidgetAPI.t(key: string, def: string) -> string
    //     Returns a translation string by key. I there is no translation matching the key
    //     default will be returned.
    //
    //     It will return the default if there is no I18n-object found
    BaseWidget.prototype.t = function t(key, def)  {
        return window.Translations._(key, def);
    };

    /////////////////////////////////////////////////////////////////////////////////////
    // WidgetAPI.ajax(url: string, config: object) -> deferred
    //     Issues an ajax request. when config.data is an object it will try to match
    //     those configuration objects to any rails-formatted placeholder in the URL.
    //
    //     Should this replaced placeholder be an array, it will be joined using a
    //     comma.
    BaseWidget.prototype.ajax = function ajax(url, config) {
        var promise = new Promise(function(resolve, reject) {
            require('widgets/helpers/ajax').then(function(AjaxHelpers) {
                var data = config.data || {};
                var method = (config.method || 'get');
                delete config['method'];
                delete config['data'];
                AjaxHelpers.request(method, url, data, config).then(resolve, reject);
            }, reject);
        });
        var def = this.resolve_on(promise);
        if (config.context === undefined) {
            return def;
        } else {
            return this.resolve_with(def, config.context);
        }
    };

    BaseWidget.prototype.request = function request(method, url, data, config) {
        return new Promise(function(rs, rj) {
            require('widgets/helpers/ajax').then(function(AjaxHelpers){
                AjaxHelpers.request(method, url, data, config).then(rs, rj);
            }, rj);
        });
    }
    BaseWidget.prototype.request.get = function request$get(url, data, config) {
        return window[api].request("get", url, data, config);
    }
    BaseWidget.prototype.request.post = function request$post(url, data, config) {
        return window[api].request("post", url, data, config);
    }

    /////////////////////////////////////////////////////////////////////////////////////
    // WidgetAPI.submit_form_async(jqo: jQuery, url: string, config: object) -> deferred
    //     Submits the form using an Ajax-Request.
    BaseWidget.prototype.submit_form_async = function submit_form_async(form) {
        var serialized = this.serialize_form(form);
        var action = form.attr("action");
        var method = form.attr("method");

        return this.ajax(action, {data: serialized, method: method});
    };

    /////////////////////////////////////////////////////////////////////////////////////
    // WidgetAPI.ajax_load(jqo: jQuery, url: string, config: object) -> deferred
    //     Replaces jqo-html with the result of the ajax-deferred.
    BaseWidget.prototype.ajax_load = function ajax_load(jqo, url, config) {
        return this.ajax(url, config).done(function(data) {
            jqo.html(data);
        });
    };

    /////////////////////////////////////////////////////////////////////////////////////

    BaseWidget.prototype.on = function on() {
        if (this.body === undefined)
            return;
        this.body.on.apply(this.body, arguments);
        
        return this;
    };

    BaseWidget.prototype.trigger = function trigger() {
        if (this.body === undefined)
            return;

        return this.body.trigger.apply(this.body, arguments)
    };

    var mobileAndTabletcheck = function mobileAndTabletcheck() {
        var check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    };

    BaseWidget.prototype.document_ready = function document_ready(handler) {
        if (!mobileAndTabletcheck()) {
            $(document).ready(handler);
            return;
        }

        console.debug("Deferring to $(window).load() because of jQuery bug.");
        $(window).on("load", handler);
    };

    /////////////////////////////////////////////////////////////////////////////////////

    BaseWidget.prototype.serialize_form = function serialize_form(form) {
        var object = {};
        $.each(form.serializeArray(), function(i, e) {
            object[e.name] = e.value;
        });
        return object;
    };

    //////////////////////////////////////////////////////////////////////////////////////

    BaseWidget.prototype.template = function(template) {
        if (typeof template !== "string") template = template.html();
        var html = _.template(template, underscore_template_settings);
        return function(values) {
            return $(html(values));
        };
    };

    BaseWidget.prototype.render_template = function template(template, data) {
        return this.template(template)(data);
    };

    ////////////////////////////////////////////////////////////////////////////////////////
    // WidgetAPI.deferred(deferred|boolean) -> deferred
    //     Creates a deferred. If not a boolean, it will fall back to resolve_on
    BaseWidget.prototype.deferred = function deferred(dependant) {
        var deferred = $.Deferred();
        if (typeof dependant === "boolean") {
            if (dependant) {
                deferred.resolve();
            } else {
                deferred.reject();
            }
        } else if (dependant !== null && dependant !== undefined) {
            this.resolve_on(deferred, dependant);
        }
        return deferred;
    };

    ////////////////////////////////////////////////////////////////////////////////////////
    // WidgetAPI.promise(func[resolve, reject]) -> deferred
    //     Creates a deferred with the same API as promises.
    BaseWidget.prototype.promise = function deferred(func) {
        var deferred = $.Deferred();

        var resolve = function _resolve() { deferred.resolve.apply(deferred, arguments); };
        var reject = function _reject() { deferred.reject.apply(deferred, arguments); };

        func(resolve, reject);
        return deferred.promise();
    };

    ////////////////////////////////////////////////////////////////////////////////////////
    // WidgetAPI.resolve(any) -> deferred
    //     Creates a resolved promise.
    BaseWidget.prototype.resolve = function resolve(v) {
        return this.promise(function(rs){rs(v);});
    };

    ////////////////////////////////////////////////////////////////////////////////////////
    // WidgetAPI.reject(any) -> deferred
    //     Creates a rejected promise.
    BaseWidget.prototype.reject = function reject(v) {
        return this.promise(function(rj){rj(v);});
    };

    ////////////////////////////////////////////////////////////////////////////////////////
    // WidgetAPI.resolve_on(array[deferred|function]|deferred|function)             -> deferred
    // WidgetAPI.resolve_on(deferred, array[deferred|function]|deferred|function)   -> deferred
    //     Resolves a deferred that will resolve once all (or if only given a single object
    //     given the single one) functions and deferreds are run.
    BaseWidget.prototype.resolve_on = function resolve_on(deferred, dependant) {
        if (dependant == null) {
            dependant = deferred;
            deferred = this.deferred();
        };

        // Resolve on arrays so we can ensure we get promises back.
        if (Array.isArray(dependant)) {
            var $this = this;
            dependant = $.map(dependant, function(single, index) {
                return $this.resolve_on(single);
            });
            dependant = $.when.apply($, dependant);
        };

        // Resolve on functions
        if (typeof dependant === "function") {
            try {
                deferred.resolve(dependant());
            } catch (e) {
                deferred.reject(e);
            };

        // Resolve on other promises
        } else if (dependant.done !== undefined) {
            dependant.done(deferred.resolve).fail(deferred.reject);

        } else if (dependant.then !== undefined) {
            dependant.then(deferred.resolve, deferred.reject);

        // Fail otherwise
        } else {
            throw new TypeError("We can only resolve on functions and promises");
        };

        return deferred.promise();
    };

    ////////////////////////////////////////////////////////////////////////////////////////
    // WidgetAPI.resolve_with(deferred, obj)
    BaseWidget.prototype.resolve_with = function resolve_with(deferred, obj) {
        var def = this.deferred();
        deferred.then(function() {
            def.resolveWith.apply(def, [obj, arguments])
        }, function() {
            def.rejectWith.apply(def, [obj, arguments])
        });
        return def;
    };

    ////////////////////////////////////////////////////////////////////////////////////////
    // WidgetAPI.resolve_first(array[deferred|function]|deferred|function)            -> deferred
    // WidgetAPI.resolve_first(deferred, array[deferred|function]|deferred|function)  -> deferred
    //     Resolves a deferred that will resolve when the first (or if only given a single
    //     object given the single one) functions and deferreds are completed.
    BaseWidget.prototype.resolve_first = function resolve_first(deferred, dependant) {
        if (dependant == null) {
            dependant = deferred;
            deferred = this.deferred();
        };

        dependant = _.map(dependant, function(single_deferred) {return this.resolve_on(single_deferred)});

        _.each(dependant, function(single_deferred) {
            single_deferred.then(function(result) {
                if (deferred.state() !== "pending") return;
                deferred.resolve(result);
            }, function(result) {
                if (deferred.state() !== "pending") return;
                deferred.reject(result);
            })
        });

        return deferred;
    };

    ////////////////////////////////////////////////////////////////////////////////////////
    // WidgetAPI.poll(function, number=100) -> deferred
    //     Queries the function every `number`-milliseconds and if the function returns
    //     a truthy value, it will resolve the returned deferred with the given result.
    //
    //     It will automatically stop polling when the deferred is resolved or rejected
    //     by any other mean.
    BaseWidget.prototype.poll = function poll(query, every) {
        every = every || 100;
        var deferred = this.deferred();

        var cur_id = setInterval(function() {
            if (deferred.state() !== "pending") {
                clearInterval(cur_id);
                return;
            }

            var result = query();
            if (!!result)
                deferred.resolve(result);
        }, every);

        return deferred;
    };

    ////////////////////////////////////////////////////////////////////////////////////////
    // WidgetAPI.wait(millis: number, reject: boolean=false) -> deferred
    //     Deferred-wrapper around setTimeout
    //
    //     If reject is a nonzero value, it will reject the deferred instead of resolving
    //     it.
    BaseWidget.prototype.wait = function wait(timeout, reject) {
        return this.promise(function(rs,rj){setTimeout((!!reject?rj:rs), timeout)})
    };

    ////////////////////////////////////////////////////////////////////////////////////////
    // WidgetAPI.extend(base: Constructor, child: Constructor) -> Constructor
    //     Makes child a subclss of base.
    BaseWidget.prototype.extend = function extend(base, child) {
      child.prototype = obj_create(base.prototype);
      child.prototype.constructor = child;
      return child;
    };

  ////////////////////////////////////////////////////////////////////////////////////////

    var obj_create = function obj_create(obj) {
        if (typeof Object.create === "function") {
            return Object.create(obj);
        };

        function inherited() {}
        inherited.prototype = obj;
        return new inherited();
    };

    ////////////////////////////////////////////////////////////////////////////////////////
    // BaseWidget(cls_name:null|string, func: function, base:object=<BaseWidgetBase>) -> object
    //     Creates a new Widget-Class.
    window[name] = window[name] || function(cls_name, func, base) {
        if (cls_name !== null) {
            console.debug("Polluting window Namespace with class: " + cls_name);
            window[cls_name] = window[cls_name] || func;
        }

        if (base === undefined)
            base = BaseWidget;

        func.prototype = obj_create(base.prototype);
        func.prototype.constructor = func;

        return func;
    };

    window[cls] = BaseWidget

    window[api] = window[api] || new BaseWidget();
    window[api].modules = window.TMModuleLoader;

    window.TMModuleLoader.module('widgets/class', ()=>BaseWidget);
    window.TMModuleLoader.module('widgets/api', function() { return window[api]; });
    window.TMModuleLoader.module('widgets/base', function() { return (function BaseWidgetModule(func, base) {
        return window[name](null, func, base);
    }); });
})(window["$"], window, document, "BaseWidget", "WidgetAPI", "Widget");

